import type { IInitializePageAnalyticFilter } from '../hooks/useInitializePageAnalyticFilter';
import type { IInitializePageAnalytic } from '../hooks/useInitializePageAnalytic';
import type { ReactNode } from 'react';

import { useInitializePageAnalyticFilter } from '../hooks/useInitializePageAnalyticFilter';
import { useInitializePageAnalytic } from '../hooks/useInitializePageAnalytic';
import { createContext, useContext, useMemo } from 'react';

export interface TemplateFilterContext extends IInitializePageAnalytic {
  pageAnalyticFilterState: IInitializePageAnalyticFilter;
}

export interface PageAnalyticProviderProps {
  children: ReactNode;
  isQueryPreviousData?: boolean;
  isSaveDateTimeToLocalStorage?: boolean;

  defaultSortValue?: string;
}

export const PageAnalyticContext = createContext<TemplateFilterContext | undefined>(undefined);

export const PageAnalyticProvider: React.FC<PageAnalyticProviderProps> = ({
  children,
  isQueryPreviousData,
  isSaveDateTimeToLocalStorage,
  defaultSortValue,
}) => {
  const initializePageAnalyticFilter = useInitializePageAnalyticFilter(defaultSortValue);
  const initializePickTemplate = useInitializePageAnalytic({
    isQueryPreviousData,
    isSaveDateTimeToLocalStorage,
    sortSelected: initializePageAnalyticFilter.sortSelected,
    queryValue: initializePageAnalyticFilter.queryValue,
    filterPageTypes: initializePageAnalyticFilter.filterPageTypes,
  });

  const contextValue = useMemo(
    () => ({
      ...initializePickTemplate,
      pageAnalyticFilterState: initializePageAnalyticFilter,
    }),
    [initializePickTemplate, initializePageAnalyticFilter],
  );
  return (
    <PageAnalyticContext.Provider value={contextValue}>{children}</PageAnalyticContext.Provider>
  );
};

export const usePageAnalyticContext = () => {
  const context = useContext(PageAnalyticContext);
  if (!context) {
    throw new Error('usePageAnalyticContext must be used within a PageAnalyticProvider');
  }
  return context;
};
